<template>
  <tr class="panel-row brutoplate-row" v-click-outside="validateAmount" :data-dim="materialDimensions">
    <td class="index">

      <div class="index-invalid" v-if="panelInvalid">
        <font-awesome-icon icon="exclamation-triangle" class="font-awesome-icon invalid-panel"/>
      </div>

      <template v-else>
        {{ panel.id }}
      </template>
    </td>
    <td class="length">
      <input placeholder="mm" disabled type="text" :value="panel.length" class="form-control"/>
    </td>
    <td class="width">
      <input placeholder="mm" disabled type="text" :value="panel.width" class="form-control"/>
    </td>
    <td class="amount">
      <input
        :id="'amount-' + panel.id"
        ref="amount"
        v-model="panel.amount"
        v-on:keydown.left.prevent="leftElement('width')"
        v-on:keydown.up.prevent="upElement('amount')"
        v-on:keydown.down.prevent="downElement('amount')"
        v-on:keydown.right.prevent="rightElement('l1')"
        v-on:keydown.enter.prevent="rightElement('l1')"
        :class="{'is-invalid': amountInvalid === true}"
        v-on:blur="validateRow()"
        onwheel="this.blur()"
        type="number"
        class="form-control"
        min="0"
      >
      <b-tooltip :show="amountInvalid" id="amountTooltip" ref="amountTooltip" :target="() => $refs['amount']" variant="danger" placement="bottom" triggers="manual">{{ amountMessage }}</b-tooltip>
    </td>
    <td class="reference">
      <input
        ref="reference"
        v-model="panel.reference"
        v-on:keydown.left.prevent="leftElement('b2')"
        v-on:keydown.up.prevent="upElement('reference')"
        v-on:keydown.down.prevent="downElement('reference')"
        v-on:keydown.right.prevent="downElement('length')"
        v-on:keydown.tab.prevent="downElement('length')"
        v-on:keydown.enter.prevent="downElement('length')"
        type="text"
        class="form-control reference"
        maxlength="30"
      >
    </td>
    <td class="actions">
      <template>
        <img src="images/icon-add-row.svg" :id="'copy-row-' + panel.id" ref="copy-row" class="font-awesome-icon action copy-row svg-inline--fa fa-w-18" @click="insert(panel)"/>
        <b-tooltip :target="() => $refs['copy-row']">Regel invoegen</b-tooltip>
        <font-awesome-icon :id="'trash-row-' + panel.id" ref="trash-row" class="font-awesome-icon action trash-row" @click="trashPanel(panel)" icon="trash-alt"/>
        <b-tooltip :target="() => $refs['trash-row']">Regel verwijderen</b-tooltip>
      </template>
    </td>
  </tr>
</template>

<script>
  import { REMOVE_PANEL, MUTATE_PANELS, SAVE_ORDER_LOCAL_STORAGE, MUTATE_CALCULATING_STATUS } from '../../../store/types'
  import vClickOutside from 'v-click-outside'
  import { panelValidation } from '../../../mixins/panel-validation'
  import { EventBus } from '../../../bus'

  export default {
    props: ['panel'],
    data() {
      return {
        length: null,
        width: null,
        amount: null,
        amountInvalid: false,
        amountMessage: null
      }
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    mixins: [panelValidation],
    computed: {
      material() {
        return this.$store.getters.material
      },
      panels() {
        return !this.$store.getters.panels ? [] : this.$store.getters.panels
      },
      panelInvalid() {
        return this.widthInvalid === true || this.amountInvalid === true
      },
      cart() {
        return !this.$store.getters.cart ? null : this.$store.getters.cart
      },
      side1() {
        return this.$store.getters.materialSide1
      },
      side2() {
        return this.$store.getters.materialSide2
      },
      materialDimensions() {
        return !this.$store.getters.materialDimensions ? null : this.$store.getters.materialDimensions
      }
    },
    watch: {
      'panel.amount': {
        handler(newVal, oldVal) {
          this.amount = !newVal ? null : newVal
          // this.validateRow()
          if (newVal !== oldVal) {
            this.resetCalculateStatus()
          }
          this.saveCart()
        }
      },
      'panel.reference': {
        handler(newVal, oldVal) {
          this.reference = !newVal ? null : newVal
          this.saveCart()
        }
      }
    },
    methods: {
      // Managing panels
      copy(panel) {
        let panelToCopy = this.panels.find((x) => {
          return x.id === panel.id
        })

        if (panelToCopy) {
          let newPanel = JSON.parse(JSON.stringify(panel))
          newPanel.id = this.panels.length + 1
          this.panels.push(newPanel)
        }
      },
      insert(panel) {
        if (panel.valid) {
          let newPanel = { id: panel.id + 1, length: null, width: null, amount: null, l1: false, l2: false, b1: false, b2: false, reference: null, valid: null }

          // create new array & insert the selected panel
          let newpanels = [...this.panels]
          newpanels.splice(panel.id, 0, newPanel)
          newpanels.map(function (x, i) {
            x.id = i + 1
          })
          this.$store.commit(MUTATE_PANELS, newpanels)
        }
      },
      trashPanel(panel) {
        if (panel.amount) {
          this.resetCalculateStatus()
        }
        this.$store.dispatch(REMOVE_PANEL, panel)
      },
      saveCart() {
        if (this.panel.valid) {
          this.$store.dispatch(SAVE_ORDER_LOCAL_STORAGE, this.cart)
        }
      },
      resetCalculateStatus() {
        if (this.panel.valid === true) {
          this.$store.commit(MUTATE_CALCULATING_STATUS, null)
        }
      },
      // Validation
      validateRow() {
        this.validateFormat()
      },
      validateAmount() {
        // No validation needed until switching sections or calculating price
        this.isValid()
      },
      validateFormat() {
        // No validation needed until switching sections or calculating price
        this.isValid()
      },
      isValid() {
        if (this.panel.width === null || this.panel.amount === null) {
          this.panel.valid = null
        } else {
          this.panel.valid = this.amountInvalid === false
        }
      }
    },
    created() {
      EventBus.$on('update-dimensions', data => {
        if (this.material.total_dimensions) {
          this.length = this.material.total_length
          this.panel.length = this.material.total_length
          this.width = this.material.total_width
          this.panel.width = this.material.total_width
        }
      })
      EventBus.$on('validate-row', data => {
        this.validateRow()
      })
    },
    mounted() {
      if (this.panel.length) {
        this.length = this.panel.length
      }
      if (this.panel.width) {
        this.width = this.panel.width
      }
      if (this.panel.amount) {
        this.amount = this.panel.amount
      }
      this.validateRow()
    },
    updated() {
      if (this.material) {
        this.panel.length = this.material.total_length
        this.panel.width = this.material.total_width
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-danger {
    margin-left: 5px;
  }

  .form-control {
    padding: 0px;

    &.reference {
      padding: 3px;
    }

    &:disabled {
      background-color: #f2f2f2;
    }
  }

  .tool .furniturepanel-rows input.checkbox-side[type=checkbox]:disabled + label {
    background-color: #f2f2f2;
  }
</style>
